import { PortalHost } from "@gorhom/portal";
import React, { FC, useCallback } from "react";
import { Outlet } from "react-router";
import { Layout } from "@lookiero/sty-psp-ui";
import { OfferingLayout as OfferingLayoutTemplate } from "../../components/templates/offeringLayout/OfferingLayout";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { Offering } from "../../shared/types";
import {
  STORAGE_KEY_CATEGORIES_SCROLL,
  STORAGE_KEY_HOME_SCROLL,
  STORAGE_KEY_TRENDING_FOR_YOU_SCROLL,
} from "../../shared/util/storageKeys";
import { DEFAULT_SCROLL_VALUE } from "../completeYourLook/CompleteYourLook.definition";
import { OfferingHeader } from "../offeringHeader/OfferingHeader";
import { useActiveOffering } from "../offeringHeader/useActiveOffering/useActiveOffering";

const OFFERING_HEADER_PORTAL_HOST = "LookInOfferingHeader";

const SCROLL_STORAGE_KEY_BY_OFFERING: Record<Offering, string> = {
  [Offering.COMPLETE_YOUR_LOOK]: STORAGE_KEY_HOME_SCROLL,
  [Offering.TRENDING_FOR_YOU]: STORAGE_KEY_TRENDING_FOR_YOU_SCROLL,
  [Offering.CATEGORIES]: STORAGE_KEY_CATEGORIES_SCROLL,
  [Offering.SALES]: STORAGE_KEY_CATEGORIES_SCROLL,
};

interface OfferingLayoutProps {
  readonly layout: Layout;
}

const OfferingLayout: FC<OfferingLayoutProps> = ({ layout }) => {
  const { store } = useStaticInfo();
  const activeOffering = useActiveOffering();

  const handleOnPressHeader = useCallback(async () => {
    if (activeOffering) {
      await store.set(SCROLL_STORAGE_KEY_BY_OFFERING[activeOffering], DEFAULT_SCROLL_VALUE);
    }
  }, [activeOffering, store]);

  return (
    <OfferingLayoutTemplate
      layout={layout}
      header={
        <OfferingHeader onPress={handleOnPressHeader}>
          <PortalHost name={OFFERING_HEADER_PORTAL_HOST} />
        </OfferingHeader>
      }
    >
      <Outlet />
    </OfferingLayoutTemplate>
  );
};

export { OfferingLayout, OFFERING_HEADER_PORTAL_HOST };
